import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	PUT_DIRECT_FLIGHT: type('[flightsFilter] put directFlight '),
	PUT_CABIN_OPTIONS: type('[flightsFilter] put cabinOptions'),
	PUT_BAGGAGE_INCLUDED: type('[flightsFilter] put baggageIncluded'),
	PUT_ONLY_REFUNDABLE: type('[flightsFilter] put onlyRefundable'),
	PUT_SCHEDULE: type('[flightsFilter] put schedule'),
	PUT_AIRLINE: type('[flightsFilter] put airline'),
	PUT_AIRLINES: type('[flightsFilter] put airlines'),
	PUT_TYPE_STUDENT: type('[flightsFilter] put type student'),
	PUT_TYPE_LIVE_AZORES_MADEIRA: type('[flightsFilter] put type azores madeira'),
	PUT_BOOK_AWARD_FLIGHTS: type('[flightsFilter] put bookAwardFlights'),
	PUT_STAR_ALLIANCE_FLIGHTS: type('[flightsFilter] put starAllianceFLights'),
	PUT_PAY_WITH_MILES_EDITABLE_STATE: type('[flightsFilter] put payWithMilesEditableState'),
	PUT_FLIGHT_WITH_MILES: type('[flightsFilter] put flightWithMiles'),
	RESET_ADVANCE_SEARCH_FILTERS: type('[flightsFilter] reset advance search filters'),
	RESET: type('[flightsFilter] reset'),
	RESET_BOOKAWARDFLIGHTS: type('[flightsFilter] reset bookAwardFlights')
};

export class PutDirectFlight implements Action {
	type = ActionTypes.PUT_DIRECT_FLIGHT;
	/**
	 *Creates an instance of PutDirectFlight.
	 * @param {boolean} payload
	 * @memberof PutDirectFlight
	 */
	constructor(public payload: boolean) { }
}

export class PutCabinOptions implements Action {
	type = ActionTypes.PUT_CABIN_OPTIONS;
	/**
	 *Creates an instance of PutCabinOptions.
	 * @param {string} payload
	 * @memberof PutCabinOptions
	 */
	constructor(public payload: string) { }
}

export class PutBaggageIncluded implements Action {
	type = ActionTypes.PUT_BAGGAGE_INCLUDED;
	/**
	 *Creates an instance of PutBaggageIncluded.
	 * @param {boolean} payload
	 * @memberof PutBaggageIncluded
	 */
	constructor(public payload: boolean) { }
}

export class PutOnlyRefundable implements Action {
	type = ActionTypes.PUT_ONLY_REFUNDABLE;
	/**
	 *Creates an instance of PutOnlyRefundable.
	 * @param {boolean} payload
	 * @memberof PutOnlyRefundable
	 */
	constructor(public payload: boolean) { }
}

export class PutSchedule implements Action {
	type = ActionTypes.PUT_SCHEDULE;
	/**
	 *Creates an instance of PutSchedule.
	 * @param {Array<any>} payload
	 * @memberof PutSchedule
	 */
	constructor(public payload: Array<any>) { }
}

export class PutAirline implements Action {
	type = ActionTypes.PUT_AIRLINE;
	/**
	 *Creates an instance of PutCabinOptions.
	 * @param {string} payload
	 * @memberof PutAirline
	 */
	constructor(public payload: string) { }
}

export class PutAirlines implements Action {
	type = ActionTypes.PUT_AIRLINES;
	/**
	 *Creates an instance of PutCabinOptions.
	 * @param {string} payload
	 * @memberof PutAirlines
	 */
	constructor(public payload: Array<string>) { }
}

export class PutTypeStudent implements Action {
	type = ActionTypes.PUT_TYPE_STUDENT;
	/**
	 *Creates an instance of PutTypeStudent.
	 * @param {string} payload
	 * @memberof PutTypeStudent
	 */
	constructor(public payload: string) { }
}

export class PutTypeLiveAzoresMadeira implements Action {
	type = ActionTypes.PUT_TYPE_LIVE_AZORES_MADEIRA;
	/**
	 *Creates an instance of TypeLiveAzoresMadeira.
	 * @param {string} payload
	 * @memberof PutTypeLiveAzoresMadeira
	 */
	constructor(public payload: string) { }
}

export class PutBookAwardFlights implements Action {
	type = ActionTypes.PUT_BOOK_AWARD_FLIGHTS;

	/**
	 *Creates an instance of PutBookAwardFlights.
	 * @param {boolean} payload
	 * @memberof PutBookAwardFlights
	 */
	constructor(public payload: boolean) { }
}

export class PutStarAllianceFlights implements Action {
	type = ActionTypes.PUT_STAR_ALLIANCE_FLIGHTS;

	/**
	 *Creates an instance of PutStarAllianceFlights.
	 * @param {boolean} payload
	 * @memberof PutStarAllianceFlights
	 */
	constructor(public payload: boolean) { }
}

export class PutPayWithMilesEditableState implements Action {
	type = ActionTypes.PUT_PAY_WITH_MILES_EDITABLE_STATE;

	/**
	 *Creates an instance of PutAwardEligibleRoute.
	 * @param {boolean} payload
	 * @memberof PutAwardEligibleRoute
	 */
	constructor(public payload: boolean) { }
}

export class PutFlightWithMiles implements Action {
	type = ActionTypes.PUT_FLIGHT_WITH_MILES;

	/**
	 *Creates an instance of PutFlightWithMiles.
	 * @param {boolean} payload
	 * @memberof PutFlightWithMiles
	 */
	constructor(public payload: boolean) { }
}

export class ResetAdvanceSearchFiltersAction implements Action {
	type = ActionTypes.RESET_ADVANCE_SEARCH_FILTERS;

	/**
	 *Creates an instance of ResetAdvanceSearchFiltersAction.
	 * @param {*} [payload]
	 * @memberof ResetAdvanceSearchFiltersAction
	 */
	constructor(public payload?) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export class ResetBookAwardFlights implements Action {
	type = ActionTypes.RESET_BOOKAWARDFLIGHTS;

	/**
	 *Creates an instance of ResetBookAwardFlights.
	 * @param {*} [payload]
	 * @memberof ResetBookAwardFlights
	 */
	constructor(public payload?) { }
}

export type Actions =
	PutDirectFlight |
	PutCabinOptions |
	PutBaggageIncluded |
	PutOnlyRefundable |
	PutSchedule |
	PutAirline |
	PutAirlines |
	PutBookAwardFlights |
	PutTypeLiveAzoresMadeira |
	PutTypeStudent |
	PutStarAllianceFlights |
	PutPayWithMilesEditableState |
	PutFlightWithMiles |
	ResetAdvanceSearchFiltersAction |
	ResetAction |
	ResetBookAwardFlights;
